import React from 'react';
import PropTypes from 'prop-types';
// import { FaUser, FaSignOutAlt, FaHome } from 'react-icons/fa';

// import { useAuth } from '~/hooks';
import {
  Container,
  Content,
  // MobileHeader,
  // UserInfo,
  // MobileFooter,
} from './styles';

export default function MobileLayout({ children }) {
  // const { user, signOut } = useAuth();

  // const handleSignOut = () => {
  //   signOut();
  // };

  // const handleGoHome = () => {
  //   window.location.href = '/mobile-protocol';
  // };

  return (
    <Container>
      {/* <MobileHeader>
        <h1>Diretiva1</h1>
        <UserInfo>
          <div>
            <FaUser size={16} />
            <span>{user?.name || 'Usuário'}</span>
          </div>
        </UserInfo>
      </MobileHeader> */}

      <Content>{children}</Content>

      {/* <MobileFooter>
        <button type="button" onClick={handleGoHome}>
          <FaHome size={20} />
          <span>Início</span>
        </button>
        <button type="button" onClick={handleSignOut}>
          <FaSignOutAlt size={20} />
          <span>Sair</span>
        </button>
      </MobileFooter> */}
    </Container>
  );
}

MobileLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
